<template>
  <div style="height: 100%">
    <div v-if="this.loading" class="loader">Loading...</div>

    <div v-else>
      
      <div>
        <EditAssetForm
          v-if="this.toggleEditAssetForm == true"
          :machine="this.currenteditedasset"
          v-on:update-asset-locally="updateAssetLocally($event)"
          v-on:close-EditAssetForm="toggleEditAssetFormmethod()"
        />
        <DeleteAssetForm
          v-if="this.toggleDeleteAssetForm == true"
          :machine="this.currentdeletingasset"
          v-on:machine-deleted="deleteAssetLocally($event)"
          v-on:close-DeleteAssetForm="toggledeleteassetformmethod()"
        />
      </div>


    <div 
      v-if="
          this.toggleEditAssetForm == false &&
          this.toggleDeleteAssetForm == false 
      ">
      <el-card style="width: 85%; margin:2% auto; padding:">

             <div style="text-align: right;">
  <el-dropdown @command="selectProperty">
  <el-button type="primary">
    {{propertySelected}} <i class="el-icon-arrow-down el-icon--right"></i>
  </el-button>
  <el-dropdown-menu slot="dropdown">
    <el-dropdown-item 
    v-for="(property, index) in propertiesOfReturnedAssets"
     :command="property"
    :key="index"> {{property}} </el-dropdown-item>
  </el-dropdown-menu>
</el-dropdown>
   </div>

        <el-input
          v-model="search"
          size="mini"
          style="width: 30%; padding: 20px; float: right;"
          placeholder="Type to search in machine name"
        />

        <el-table
          :data="this.selectedPropertyAssets.filter(data => !search || data.machinename.toLowerCase().includes(search.toLowerCase()))"
          height="60vh"
          style="width: 100%;"
        >


          <el-table-column width="100" align="center">
            <template slot-scope="scope">
              <el-image style="width: 50px; height: 50px" :src="scope.row.imageurl[0]" lazy></el-image>
            </template>
          </el-table-column>

          <el-table-column label="Machine name" sortable :sort-method="sortMachineNames">
            <template slot-scope="scope">
              <router-link :to="{ path: `/MachinebyId/${scope.row.machineid}` }">
                <a>{{scope.row.machinename}}</a>
              </router-link>
            </template>
          </el-table-column>


          <el-table-column prop="description" label="Description" sortable>

          </el-table-column>
        
          <el-table-column
            v-if="this.$route.path.includes('UsersAssets')"
            prop="propertyname"
            label="Property name"
            sortable
          ></el-table-column>

          <el-table-column
            v-if="this.$route.path.includes('UsersAssets')"
            prop="ownername"
            label="Owner name"
            sortable
          ></el-table-column>

           <el-table-column prop="installdate" label="Install date">
                <template slot-scope="scope">
                  {{ scope.row.installdate | moment(
                    'timezone',
                     $timeZone,
                    'MMM DD YYYY hh:mm A') }}
                </template>
              </el-table-column>

          <el-table-column  width="60:px;">
            
              <template slot-scope="scope">


                               <div>
                                  <el-dropdown
                                    v-if="scope.row.candelete == true || scope.row.canedit == true "
                                    trigger="click"
                                    style="margin-top:-10px;"
                                  >
                                    <el-button v-on:click.stop type="text">
                                      <i class="el-icon-s-operation"></i>
                                    </el-button>
                                    <el-dropdown-menu slot="dropdown">

                                      <el-dropdown-item>
                                        <el-button
                                          v-if="scope.row.canedit == true"
                                          @click.native="
                                            toggleEditAssetFormmethod(scope.row)
                                          "
                                          type="text"
                                          style="margin-left:5px; margin-right:5px; color:unset;"
                                        >
                                          <i class="fa fa-edit mt-2" /> Edit
                                          Asset
                                        </el-button>
                                      </el-dropdown-item>

                                      <el-dropdown-item>
                                        <el-button
                                          v-if="scope.row.candelete == true"
                                          type="text"
                                          @click.native="
                                            toggledeleteassetformmethod(scope.row)
                                          "
                                          style="margin-left:5px; margin-right:5px; color:unset;"
                                        >
                                          <i class="fa fa-trash mt-2" /> Delete
                                          Asset
                                        </el-button>
                                      </el-dropdown-item>

                                    </el-dropdown-menu>
                                  </el-dropdown>
                                </div>
            
                  </template>



           </el-table-column>

        <el-table-column width="110px;" style="">
         <template slot-scope="scope">

             <el-badge v-if="scope.row.unreadlogcount > 0" style="bottom: -15px;" :value="scope.row.unreadlogcount">
                <i style="height: 50px; color: rgb(128, 128, 128);" class="fa-lg far fa-sticky-note"></i>
            </el-badge>

            <el-badge v-if="scope.row.unreadcommentcount > 0" style="bottom: -15px;" :value="scope.row.unreadcommentcount">
              <i style="height: 50px; color: rgb(128, 128, 128); margin-left: 32px;" class="fa-lg far fa-comment-dots"></i>  <i ></i>
            </el-badge>

         </template>
        </el-table-column>

        </el-table>
      </el-card>
    </div>
    </div>
  </div>
</template>
<script>
import EventService from "@/services/EventService.js";
import Router from "vue-router";
import EditAssetForm from "@/components/assets/EditAssetForm.vue";
import DeleteAssetForm from "@/components/assets/DeleteAssetForm.vue";

export default {
  components: {
    EditAssetForm,
    DeleteAssetForm
  },

  data() {
    return {
      propertyassets: null,
      search: "",
      currentRow: null,
      loading: true,
      toggleEditAssetForm: false,
      toggleDeleteAssetForm: false,
      propertiesOfReturnedAssets: [],
      propertySelected:"",
      allAssets: []
    };
  },

  methods: {


  selectProperty(propertyname){
   this.propertySelected = propertyname;
  },


        updateAssetLocally(updatedassetpackage) {
      this.$set(
        this.allAssets.machinelists,
        this.allAssets.machinelists.indexOf(updatedassetpackage[1]),
        updatedassetpackage[0]
      );
    },
        toggleEditAssetFormmethod(machine) {
      this.toggleEditAssetForm = !this.toggleEditAssetForm;
      console.log(machine)
      this.currenteditedasset = machine;
      this.changeBackButton();
    },
      deleteAssetLocally($event) {
      console.log("delete asset locally is running" + $event);
      // console.log(
      //   "this is the index of the property " +
      //     this.propertyassets.indexOf($event)
      // );
      this.$delete(
        this.allAssets.machinelists,
        this.allAssets.machinelists.indexOf($event)
      );
    },
        toggledeleteassetformmethod(machine) {
      this.toggleDeleteAssetForm = !this.toggleDeleteAssetForm;
      this.currentdeletingasset = machine;
      this.changeBackButton();
    },
      changeBackButton() {
      this.$root.$emit("form-toggled");
    },
    sortMachineNames(a, b){
      
    if(a.machinename.toLowerCase() < b.machinename.toLowerCase()) { return -1; }
    if(a.machinename.toLowerCase() > b.machinename.toLowerCase()) { return 1; }
    return 0;

    }
  },

  created() {
    if (this.$route.path.includes("UsersAssets")) {
      EventService.getUsersAllMachines().then(response => {
        this.propertyassets = response.data;
             this.allAssets = response.data.machinelists;

        this.loading = false;


     this.allAssets = response.data.machinelists;

      // loop through all assets to check for their property names, put into array to display on dropdown
      this.allAssets.forEach(asset => {
        if(this.propertiesOfReturnedAssets.slice(-1)[0]  != asset.propertyname)
          this.propertiesOfReturnedAssets.push(asset.propertyname);
      });
      // select first property by default
      this.propertySelected = this.propertiesOfReturnedAssets[0];


      });
    } else {
      EventService.getMachinesofProperty(this.$route.params.propertyid).then(
        response => {
          this.propertyassets = response.data;
          this.loading = false;
        }
      );
    }
  },
   computed: {
   selectedPropertyAssets(){
     if(this.propertySelected != ""){
     return this.allAssets.filter(asset =>
        asset.propertyname == this.propertySelected
      );
     } 

     return this.allAssets
   }
  }
};
</script>
<style scoped>
.el-card__body {
  padding: 0px;
}

a {
  color: #02746E;
  text-decoration: underline;
}
</style>
